import React, { Fragment } from "react";
import { Link } from "react-router-dom";

class BannerOne extends React.Component {
  render() {
    return (
      <Fragment>
        <div className="wrapper-90 max-1600">
          <div className="container-fluid px-0">
            <div className="row w-100 m-0">
              <div className="col-md-12 px-0">
                {this.props.banners && this.props.banners.length > 0 && (
                  <Link
                    to={this.props.banners && this.props.banners[0].bannerUrl}
                  >
                    <img
                      src={`${
                        this.props.banners &&
                        this.props.banners[0].images &&
                        this.props.banners[0].images[0]
                      }`}
                      height="100%"
                      width="100%"
                      className="bor-rad-8"
                    />
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="all-sales-container wrapper-90 max-1600">
          <div className="container-fluid px-0">
            <div className="row">
              <div className="col-md-6 col-sm-6 my-2">
                <Link
                  to={`${
                    this.props.getHomeAds && this.props.getHomeAds[0].adUrl1
                  }`}
                >
                  <div className="sales1-content">
                    <div className="sales-heading">
                      <h3>All Sales</h3>
                      <p>
                        Discover all of todays best saving
                        <i className="fa fa-arrow-right pl-1" />
                      </p>
                    </div>
                    <div className="bg-less-img">
                      <img
                        src="./assets/images/sofa.png"
                        width="100%"
                        alt="Discover all of todays best saving"
                      />
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-md-6 col-sm-6 my-2">
                <Link
                  to={`${
                    this.props.getHomeAds && this.props.getHomeAds[0].adUrl1
                  }`}
                >
                  <div className="sales2-content">
                    <div className="sales-heading">
                      <h3>Open Box</h3>
                      <p>
                        Save big on return & like-new item
                        <i className="fa fa-arrow-right pl-1" />
                      </p>
                    </div>
                    <div className="bg-less-img">
                      <img
                        src="./assets/images/sofa.png"
                        width="100%"
                        alt="Discover all of todays best saving"
                      />
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default BannerOne;
